import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import SearchInput from '../../../components/common-inputs/SearchInput';
import CommonButton from '../../../components/common-button/CommonButton';

import scss from './FeatureWrapper.module.scss';

function FeatureWrapper({ title, onSave, isSaving, isSaveDisabled, children }) {
  const { t } = useTranslation('customers');

  const [search, setSearch] = useState('');

  return (
    <div className={scss.wrapper}>
      <span className={scss.title}>{t('assign', { feature: title })}</span>
      <div className={scss.filters}>
        <SearchInput value={search} onChange={setSearch} size='sm' maxWidth={320} name={`ai-feature-search ${title}`} />

        {onSave ? (
          <CommonButton onClick={onSave} isLoading={isSaving} disabled={isSaveDisabled} maxWidth={160}>
            {t('save')}
          </CommonButton>
        ) : null}
      </div>

      {children({ search, disabled: isSaving })}
    </div>
  );
}

export default FeatureWrapper;
